import { Getter, GetterTree } from "vuex";
import { RootState } from "@/store/RootState";
import {
  ChannelsPageGetter,
  ChannelsPageState
} from "@/components/channelsPage/types";

export const getters: GetterTree<ChannelsPageState, RootState> &
  Record<ChannelsPageGetter, Getter<ChannelsPageState, RootState>> = {
  [ChannelsPageGetter.GetCardControls](state) {
    return state.cardControls;
  },
  [ChannelsPageGetter.GetPlayedChannelId](state) {
    return state.playedChannelId;
  },
  [ChannelsPageGetter.GetPlayedChannelIndex](state) {
    return state.playedChannelIndex;
  },
  [ChannelsPageGetter.GetPlayedChannelCategory](state) {
    return state.playedChannelCategory;
  },
  [ChannelsPageGetter.GetPlayedChannelView](state) {
    return state.playedChannelView;
  },
  [ChannelsPageGetter.getActiveChannelOverlayInfo](state) {
    return state.activeChannelOverlayInfo;
  },
  [ChannelsPageGetter.getActiveInfoScreenEpgItem](state) {
    return state.activeInfoScreenEpgItem;
  },
  [ChannelsPageGetter.getShowInfoScreen](state) {
    return state.showInfoScreen;
  },
  [ChannelsPageGetter.getShowEpgScreen](state) {
    return state.showEpgScreen;
  }
};
